<template>
  <b-tab title="Informations du test">
    <b-card class="mb-4 p-3 shadow-sm">
      <b-form-group label="Nom du test *">
        <b-form-input v-model="test.name" />
      </b-form-group>

      <b-form-group label="Choix *">
        <div v-for="(score, index) in test.scoresNames" :key="index" class="input-group mb-2">
          <b-form-input v-model="test.scoresNames[index]" />
          <div class="input-group-append">
            <b-button variant="danger" size="sm" @click="removeScore(index)">✖</b-button>
          </div>
        </div>
        <b-button size="sm" variant="success" @click="addScore">+ Ajouter un choix</b-button>
      </b-form-group>

      <b-form-group label="Description">
        <b-form-textarea v-model="test.description" rows="2" />
      </b-form-group>

      <b-form-group label="Ordre de questions aléatoire ? *">
        <b-form-radio-group
          v-model="test.aleatoire"
          :options="[
            { text: 'Oui', value: true },
            { text: 'Non', value: false }
          ]"
          name="aleatoire-radio"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="primary" size="lg" @click="saveTest">Enregistrer</b-button>
      </div>
    </b-card>
  </b-tab>
</template>

<script>
export default {
  name: "TestInfo",
  props: {
    test: { type: Object, required: true }
  },
  mounted() {
    if (this.test.aleatoire === null || this.test.aleatoire === undefined) {
      this.$set(this.test, "aleatoire", false);
    }
  },
  methods: {
    addScore() {
      if (!this.test.scoresNames) this.$set(this.test, 'scoresNames', []);
      this.test.scoresNames.push('');
      this.$emit('scores-changed', this.test.scoresNames);
    },
    removeScore(index) {
      this.test.scoresNames.splice(index, 1);
      this.$emit('scores-changed', this.test.scoresNames);
    },
    async saveTest() {
      const testId = this.test._id || this.test.id;
      if (!testId) return;
      try {
        const res = await fetch(`/api/tests/${testId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.test)
        });
        if (res.ok) {
          this.$bvToast?.toast('Modifications enregistrées avec succès', {
            title: 'Succès', variant: 'success', solid: true, autoHideDelay: 3000
          });
          this.$emit('saved');
        } else {
          this.$bvToast?.toast('Erreur lors de l\'enregistrement', {
            title: 'Erreur', variant: 'danger', solid: true, autoHideDelay: 4000
          });
        }
      } catch (e) {
        this.$bvToast?.toast('Erreur réseau ou serveur lors de l\'enregistrement', {
          title: 'Erreur', variant: 'danger', solid: true, autoHideDelay: 4000
        });
      }
    }
  }
};
</script>

<style scoped>
</style>
